module.exports = __webpack_public_path__ + "img/project-1.0496bf76.jpg";